import {Filters, FilterFacet} from "../../models/Filter"

export const getOpenFiltersAndViewMoreFromExistingFilters = (
    existingFilters: Filters,
    newFilters: Filters,
): Filters => {
    const updatedFilters = {...newFilters}
    Object.keys(newFilters).forEach(filterName => {
        if (!existingFilters[filterName]) return
        if (existingFilters[filterName].isFilterOpen) {
            updatedFilters[filterName] = {...updatedFilters[filterName], isFilterOpen: true}
        }
        if ((existingFilters[filterName] as FilterFacet).isViewMoreOpen) {
            updatedFilters[filterName] = {...updatedFilters[filterName], isViewMoreOpen: true}
        }
    })
    return updatedFilters
}

export default getOpenFiltersAndViewMoreFromExistingFilters
